import { PaymentsService_paymentsServiceV4GetQuery } from '@festina/moneyin-general-types/moneyin/hooks/PaymentsService_paymentsServiceV4GetQuery'

export const useLazyFetchPayments =
  PaymentsService_paymentsServiceV4GetQuery.useLazyQuery
